// The status pill colours of today's grids (src/styles.scss .grid-status-column.<class>), as hex for
// @inavista/components `columnColors`. The class of a status comes from CommonService.getStatusClass, so the
// status → colour rule stays in one place.
const PILL_COLORS: Record<string, string> = {
  'blue': '#199efd',
  'coral': '#ff7f50',
  'grey': '#656363',
  'orange': '#f3ae4b',
  'green': '#479e47',
  'red': '#9e1414',
  'light-purple': '#9399ff',
  'aqua': '#0bf9b7',
  'exceptions': '#ca7671',
  'light-orange': '#f7a56c',
  'adjusted': '#037d50',
  'peach': '#f7a56c',
  'yellow': '#f1d300',
  'light-blue': '#68bbe3',
  // getPurchaseOrdersClass (Partially Shipped).
  'dark-orange': '#ff7f50',
  // getServiceOrdersClass / getPartOrdersClass (the dashboard count pods).
  'black': '#454545',
  'bluish': '#0f38bd',
  'bold': '#8b8d94',
};

// `statusClass` is CommonService.getStatusClass (bound): status → pill class.
export const statusPillColor = (statusClass: (status: string) => string) =>
  (value: unknown) => PILL_COLORS[statusClass(String(value ?? ''))] ?? PILL_COLORS['grey'];
